// en, de, fr, pt
export default {
  en: {
    header: {
      message: 'ini pesan en'
    },
    dashboard: {
      so_total: "Sales Order Total"
    }
  },
  cn: {
    header: {
      message: 'ini pesan cn'
    },
    dashboard: {
      so_total: "Sales Order Total CN"
    }
  }
}
